import { API } from "@/lib/api";
import { initials } from "@/lib/format";
import { cn } from "@/lib/utils";

export const UserAvatar = ({ user, className, testid }) => {
  if (user?.avatar_file_id) {
    return (
      <img
        src={`${API}/files/${user.avatar_file_id}`}
        alt={`${user.name}'s avatar`}
        className={cn("h-9 w-9 rounded-full object-cover", className)}
        data-testid={testid}
      />
    );
  }
  return (
    <span
      className={cn(
        "grid h-9 w-9 shrink-0 place-items-center rounded-full bg-muted text-xs font-semibold text-foreground",
        className
      )}
      aria-label={user?.name}
      data-testid={testid}
    >
      {initials(user?.name)}
    </span>
  );
};
